import { isIpfError } from '@ipfabric/frontend-shared-assets/utils/IpfError';
import {
  API_INVALID_ACCESS_TOKEN,
  API_INVALID_REFRESH_TOKEN,
} from '@ipfabric/utils';
import type { GlobalStateCommandFactory } from 'components/GlobalState/GlobalStateModel';
import { authenticate } from 'components/GlobalState/commands/authenticate';
import { handleInitialAppRequest } from 'components/GlobalState/commands/handleInitialAppRequest';
import { tokenCheck } from 'components/GlobalState/commands/tokenCheck';

/**
 * To be called upon app load to initialize state of user authentication.
 * Performs a token check and then authentication hydration (non-SSO path).
 * @param cmdContext Global state command context
 * @param dispatch Global state command dispatcher
 */
export const initializeAuthentication: GlobalStateCommandFactory =
  (cmdContext, dispatch) => async () => {
    try {
      await dispatch(handleInitialAppRequest, async () => {
        // Always perform token check (non-SSO path). SSO handled by initializeSSOAuthentication.
        await dispatch(tokenCheck, true);
        if (cmdContext.getState().loginStatus !== 'LOGGING_IN') {
          // hydrate state from server and reconnect sockets after tokens are refreshed
          await dispatch(authenticate);
          // user is AUTHENTICATED at this point, redirect him to homePage if he was on login page
          if (cmdContext.getState().location.pathname === '/login') {
            cmdContext.navigate('/');
          }
        }
      });
    } catch (e) {
      if (
        isIpfError(e, 'API') &&
        (e.code === API_INVALID_ACCESS_TOKEN ||
          e.code === API_INVALID_REFRESH_TOKEN)
      ) {
        cmdContext.updateState((draft) => {
          draft.loginStatus = 'LOGGED_OUT';
        });
        return;
      }
      throw e;
    }
  };
